import _ from 'lodash';

import StoryConstants from './StoryConstants';
import ProjectConstants from '../projects/ProjectConstants';

const defaultState = window.state ? window.state.stories : {};

export function stories(state = defaultState, action) {
    switch (action.type) {
        case StoryConstants.STORY_RECEIVED:
            return {
                ...state,
                [action.payload.id]: {
                    id: action.payload.id.toString(),
                    name: action.payload.name,
                    description: action.payload.description,
                    public_url: action.payload.public_url,
                    account_id: action.payload.account_id.toString(),
                    projects: action.payload.projects.map(project => project.id),
                    created_at: action.payload.created_at,
                    updated_at: action.payload.updated_at,
                    published_at: action.payload.published_at,
                }
            };
        case StoryConstants.STORY_RENAMED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    name: action.payload.name
                }
            };
        case StoryConstants.STORY_DESCRIPTION_CHANGED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    description: action.payload.description
                }
            };
        case StoryConstants.STORY_PROJECTS_UPDATED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    projects: action.payload.projects
                }
            };
        case StoryConstants.STORY_PUBLISHED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    public_url: action.payload.public_url,
                    published_at: action.payload.published_at,
                }
            };
        case StoryConstants.STORY_UNPUBLISHED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    public_url: null,
                    published_at: null,
                }
            };
        case StoryConstants.STORY_REMOVED:
            return _.pickBy(state, slide => slide.id !== action.payload.id );
        case ProjectConstants.PROJECT_REMOVED:
            return _.map(state, story => ({
                ...story,
                projects: _.filter(story.projects, project => project !== action.payload.id)
            }));
        default:
            return state;
    }
}
